import { FullscreenOutlined } from '@ant-design/icons';
import { Button, Image, Modal } from 'antd';
import * as React from 'react';
import { useState } from 'react';

import { ViewerAppryzeSimple } from './viewer-appryze-simple';

type ViewerWrapperAppryzeProps = {
    mode?: 'viewer' | 'pict';
    file: string | File | null;
    fileName?: string;
    urlPictPreview?: string;
    title?: string;
    onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

export const ViewerWrapperModalAppryze: React.FC<ViewerWrapperAppryzeProps> = ({
    file,
    mode = 'viewer',
    fileName,
    urlPictPreview,
    onClick,
    title,
}) => {
    const [isMaximyze, setIsMaximyze] = useState<boolean>(false);

    const close = (e: React.MouseEvent<HTMLButtonElement>) => {
        setIsMaximyze(false);
        e.stopPropagation();
    };

    const openModalView = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setIsMaximyze(true);
        e.stopPropagation();
    };

    return (
        <>
            {mode === 'viewer' && (
                <Button
                    onClick={openModalView}
                    type="text"
                    variant={'filled'}
                    icon={<FullscreenOutlined />}
                    style={{
                        position: 'absolute',
                        zIndex: 1000,
                        top: 0,
                        left: 0,
                    }}
                />
            )}

            {mode === 'viewer' && <ViewerAppryzeSimple file={file} fileName={fileName} context={'drawing'} />}
            {mode === 'pict' && (
                <Image
                    onClick={onClick || openModalView}
                    width={130}
                    src={urlPictPreview || undefined}
                    preview={false}
                    style={{ cursor: 'pointer', border: '1px solid #ddd' }}
                />
            )}
            <Modal
                title={'Drawing view' + (title ? ' - ' : '') + (title || '')}
                open={isMaximyze}
                onCancel={close}
                width={'90%'}
                style={{ top: 20 }}
                footer={[
                    <Button key="custom-ok" type="primary" onClick={close}>
                        Close
                    </Button>,
                ]}
            >
                <ViewerAppryzeSimple
                    file={file}
                    fileName={fileName}
                    height={'calc(100vh - 156px)'}
                    context={'drawing'}
                />
            </Modal>
        </>
    );
};
